const FIT_RESOURCE_LIST_SECTION_SELECTOR = '[data-resource-list-order-enabled]';
const FIT_RESOURCE_LIST_BLOCK_SOURCE_SELECTOR = '.section-resource-list__blocks-source';
const FIT_RESOURCE_LIST_BLOCKS_ORDERED_SELECTOR = '.section-resource-list__blocks-ordered';
const FIT_RESOURCE_LIST_WRAPPER_SELECTOR = '[data-resource-list-wrapper]';

function fitGetSectionRoots(fitRoot = document) {
  if (!(fitRoot instanceof Document || fitRoot instanceof Element)) {
    return [];
  }

  if (fitRoot instanceof Element && fitRoot.matches(FIT_RESOURCE_LIST_SECTION_SELECTOR)) {
    return [fitRoot];
  }

  if (fitRoot instanceof Element) {
    const fitClosestSection = fitRoot.closest(FIT_RESOURCE_LIST_SECTION_SELECTOR);
    if (fitClosestSection) {
      return [fitClosestSection];
    }
  }

  return Array.from(fitRoot.querySelectorAll(FIT_RESOURCE_LIST_SECTION_SELECTOR));
}

function fitGetDeclaredBlockType(fitBlock) {
  return (
    fitBlock.getAttribute('data-block-type') ||
    fitBlock.querySelector('[data-block-type]')?.getAttribute('data-block-type') ||
    ''
  );
}

function fitIsTargetBlock(fitBlock, fitTargetBlockType) {
  if (!(fitBlock instanceof Element) || typeof fitTargetBlockType !== 'string' || !fitTargetBlockType) {
    return false;
  }

  const fitDeclaredBlockType = fitGetDeclaredBlockType(fitBlock);
  if (fitDeclaredBlockType) {
    return fitDeclaredBlockType === fitTargetBlockType;
  }

  const fitBlockId = fitBlock.id || '';
  const fitBlockClassName = typeof fitBlock.className === 'string' ? fitBlock.className : '';
  return fitBlockId.includes(fitTargetBlockType) || fitBlockClassName.includes(fitTargetBlockType);
}

function fitRevealWrapper(fitWrapper, fitBlocksOrdered) {
  if (!(fitWrapper instanceof HTMLElement) || !(fitBlocksOrdered instanceof HTMLElement)) {
    return;
  }

  fitWrapper.style.display = '';
  fitBlocksOrdered.appendChild(fitWrapper);
}

function fitOrganizeSection(fitSection) {
  if (!(fitSection instanceof HTMLElement)) return;

  const fitTargetBlockType = fitSection.dataset.resourceListBlockType || '';
  const fitBlocksSource = fitSection.querySelector(FIT_RESOURCE_LIST_BLOCK_SOURCE_SELECTOR);
  const fitBlocksOrdered = fitSection.querySelector(FIT_RESOURCE_LIST_BLOCKS_ORDERED_SELECTOR);
  const fitWrapper = fitSection.querySelector(FIT_RESOURCE_LIST_WRAPPER_SELECTOR);

  if (!(fitBlocksSource instanceof HTMLElement) || !(fitBlocksOrdered instanceof HTMLElement) || !fitTargetBlockType) {
    return;
  }

  const fitAllBlocks = Array.from(fitBlocksSource.children);
  const fitFirstTargetIndex = fitAllBlocks.findIndex((fitBlock) => fitIsTargetBlock(fitBlock, fitTargetBlockType));

  if (fitFirstTargetIndex === -1) {
    fitAllBlocks.forEach((fitBlock) => fitBlocksOrdered.appendChild(fitBlock));
    fitRevealWrapper(fitWrapper, fitBlocksOrdered);
    fitBlocksSource.remove();
    return;
  }

  fitAllBlocks.forEach((fitBlock, fitIndex) => {
    const fitMatchesTarget = fitIsTargetBlock(fitBlock, fitTargetBlockType);

    if (fitMatchesTarget && fitIndex === fitFirstTargetIndex) {
      fitRevealWrapper(fitWrapper, fitBlocksOrdered);
    }

    if (fitMatchesTarget) {
      fitBlock.style.display = 'none';
    }

    fitBlocksOrdered.appendChild(fitBlock);
  });

  fitBlocksSource.remove();
}

function fitOrganizeResourceListSections(fitRoot = document) {
  fitGetSectionRoots(fitRoot).forEach((fitSection) => fitOrganizeSection(fitSection));
}

function fitHandleResourceListEvent(fitEvent) {
  const fitEventTarget = fitEvent?.target;
  if (fitEventTarget instanceof Element || fitEventTarget instanceof Document) {
    fitOrganizeResourceListSections(fitEventTarget);
    return;
  }

  fitOrganizeResourceListSections(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => fitOrganizeResourceListSections(document), { once: true });
} else {
  fitOrganizeResourceListSections(document);
}

document.addEventListener('shopify:section:load', fitHandleResourceListEvent);
document.addEventListener('shopify:block:select', fitHandleResourceListEvent);

window.FitCheck = window.FitCheck || {};
window.FitCheck.resourceListOrder = {
  organize: fitOrganizeResourceListSections,
};
